import React from "react";
import clockIcon from "../assets/tint/ico_clock.svg"

function ActiveOverride(response) {

	console.log(response)

	const [showList, setShowList] = React.useState(false)
	const [showActiveOverride, setShowActiveOverride] = React.useState(false)
	let count = 0;

	async function callActiveOverride() {
		try {
			const res = await response.response.zone

			if (res[0].overrideTimeLeft !== undefined) {
				setShowActiveOverride(true)
			}

		} catch (error) {
			setShowActiveOverride(false)
			console.log("Error while rendering Active Override " + error)
		}
	}
	callActiveOverride()


	return (
		<>
			{showActiveOverride &&
				<section className={`my-orders ${showList ? "open" : null}`}>
					<div class="orders-container">
						<div class="orders-heading">
							<h5>Active Overrides</h5>
							<a class="order-toggle" onClick={() => setShowList(!showList)}><i className={showList ? "fas fa-lg fa-chevron-up" : "fas fa-lg fa-chevron-down"}></i></a>
						</div>

						{showList &&
							<div class="list" style={{ xdisplay: "none" }}>
								<div class="orders-body-container">
									<div class="orders-body text-list">
										{response.response.zone.map((iterator, index) => {
											if (iterator.overrideTimeLeft !== null && iterator.overrideTimeLeft > 0) {
												count++
												return (
													<div class="row order-row" key={index}>
														<div class="col col-3 order-preview">
															<img src={clockIcon} />
														</div>
														<div class="col col-3 order-details">
															{ (Math.floor(iterator.overrideTimeLeft / 60) > 0) ?
															<p class="item-name">{iterator.tintLabel} : Override is active for {Math.floor(iterator.overrideTimeLeft / 60)} hour and {(iterator.overrideTimeLeft % 60)} mins.</p>
															:
															<p class="item-name">{iterator.tintLabel} : Override is active for {(iterator.overrideTimeLeft % 60)} mins.</p>
															}
														</div>
													</div>
												)
											}
										})}
										{count === 0 ?
											<div class="orders-heading">
												<p>No Active Overrides</p>
											</div>
											: null}
									</div>
								</div>
							</div>
						}

					</div>
				</section>
			}
		</>
	)
}

export default ActiveOverride